import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    compatConfig: {
        COMPONENT_V_MODEL: false
    },
    ...componentI18n('components.maturity_slider')
};
import MaturityImages from './MaturityImages.vue';
import NamedCard from './new/NamedCard.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'MaturitySlider',
    props: {
        modelValue: null,
        size: null
    },
    emits: ['update:modelValue'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_slider_field = _resolveComponent("slider-field");
            return (_openBlock(), _createBlock(NamedCard, {
                name: _ctx.$t('heading')
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(["mb-2 text-center text-gray-600 dark:text-gray-300", __props.size === 'xs' ? 'text-xxs' : 'text-sm'])
                    }, _toDisplayString(_ctx.$t('label')), 3),
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(MaturityImages, {
                            maturity: __props.modelValue,
                            class: "w-full"
                        }, null, 8, ["maturity"])
                    ]),
                    _createVNode(_component_slider_field, {
                        class: "pb-2",
                        "model-value": __props.modelValue,
                        min: 1,
                        max: 4,
                        marks: {
                            1: _ctx.$t('maturity_1.label'),
                            2: '',
                            3: '',
                            4: _ctx.$t('maturity_4.label')
                        },
                        size: __props.size,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
                    }, null, 8, ["model-value", "marks", "size"])
                ], undefined, true),
                _: 1
            }, 8, ["name"]));
        };
    }
});
